/*
 * fn: fetchRecs
 *
 * Send a request to the recs endpoint
 *
 */
import { type RecsResponseType } from '@/defs/apiLegacy/recs'
import { type RecType } from '@/defs/rec'
import { fetchApi } from '@/utils/requestUtil'

import { parseRecResponse } from './parseRecResponse'

export type RecsEndpointInputsType = {
  commander: string
  commander2?: string
  decklist?: string
  excludeLands?: boolean
}

type Props = {
  inputs: RecsEndpointInputsType
  offset?: number
}

export const fetchRecs = async ({ inputs: { commander, commander2, decklist, excludeLands }, offset }: Props) => {
  const cards =
    decklist
      ?.split('\n')
      .map((card) => ((card.match(/"/g) || []).length === 2 ? card.split('"')[1] : card))
      .filter((row): row is string => !!row && !row.startsWith('Quantity,N')) || []
  const commanders = [commander]
  if (commander2) commanders.push(commander2)

  const response = await fetchApi<RecsResponseType>({
    base: 'api',
    options: {
      body: JSON.stringify({ cards, commanders, options: { excludeLands, offset } }),
      headers: { accept: 'application/json', 'content-type': 'application/json' },
      method: 'POST',
    },
    path: '/recs',
    requiresAuth: !!offset,
  })

  const inRecs = response.data.inRecs?.map<RecType>((r) =>
    parseRecResponse({
      category: r.primary_type === 'Land' ? 'Lands to Add' : 'Cards to Add',
      defaultOrder: r.score,
      name: r.name,
    }),
  )

  const outRecs = response.data.outRecs?.map<RecType>((r) =>
    parseRecResponse({
      category: r.primary_type === 'Land' ? 'Lands to Cut' : 'Cards to Cut',
      defaultOrder: r.score,
      name: r.name,
    }),
  )

  const hasMore = response.data.more
  const errors = response.data.errors?.length ? response.data.errors : undefined

  return { errors, hasMore, inRecs, outRecs }
}
